import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconSearchlinesSparkle: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="search lines-sparkle, magnifier, document, list, page, file"><path d="M13.25 21.25H4.75V2.75H19.25V11.75" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M8.75 6.75H15.25M8.75 10.75H12.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M18.4 14H17.6L16.6 16.6L14 17.6V18.4L16.6 19.4L17.6 22H18.4L19.4 19.4L22 18.4V17.6L19.4 16.6L18.4 14Z" fill="currentColor"/></CentralIconBase>;
};

export default IconSearchlinesSparkle;
